module.exports = __webpack_public_path__ + "static/media/not-found.b6ac5f6b.svg";